import { PJAxios, sendLogin, useAppInfo, useLanguage, useParams, usePJStore, useUserInfo } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import FormRow from '../Common/FormRow';

import { Chip } from 'primereact/chip';

import { usePJSalto } from '@jaf/jaf-react-core'
import { PJButton, PJContent, PJHeader, PJPage } from '@it-polimi/pj-react-ui';

import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

function CareerServiceForm(props) {

    const location = useLocation();
    const toast = useRef(null);
    const getText = usePJStore((state) => state.i18n_getText)

    const isLogged = useUserInfo() != null;
    const userInfo = useUserInfo();
    const { storage } = usePJStore((state) => state.storage)
    const language = useLanguage();
    const appInfo = useAppInfo();

    const allegatoRef = useRef(null);

    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const otoboFunctionalEmail = dbTest ? "<helpdesk-test2-asict@polimi.it>" : "<helpdesk-asict@polimi.it>";

    const [selectedQueue, setSelectedQueue] = useState(null)


    // Usiamo useMemo per non ricalcolare i parametri ad ogni render 
    // a meno che l'URL (location.search) non cambi davvero.
    const queryParams = useMemo(() => {
        return new URLSearchParams(location.search);
    }, [location.search]);

    const categoriaList = useMemo(() => ([
        { name: getText("STUDENTE"), value: 'S' },
        { name: getText("DOCENTE"), value: 'D' },
        { name: getText("AZIENDA"), value: 'A' }
    ]), [getText]);

    useEffect(() => {
        console.log("language changed: ", language) 
    }, [language]);

    console.log("queryParams: ", Array.from(queryParams.entries()));

    const [ticketSent, setTicketSent] = useState(false)

    const [loading, setLoading] = useState(false)

    const [oggetto, setOggetto] = useState("")
    const [testo, setTesto] = useState("")

    const [nome, setNome] = useState(null)
    const [cognome, setCognome] = useState(null)
    const [email, setEmail] = useState(null)
    const [codice_persona, setCodice_persona] = useState("")
    const [allegato, setAllegato] = useState([])

    const [categoria, setCategoria] = useState(null)

    

    const [typedEmail, setTypedEmail] = useState("")

    const [categoriaPrincipaleList, setCategoriaPrincipaleList] = useState([])
    const [categoriaPrincipale, setCategoriaPrincipale] = useState(null)

    const [sottocategoriaPrincipaleList, setSottocategoriaPrincipaleList] = useState([])
    const [sottocategoriaPrincipale, setSottocategoriaPrincipale] = useState(null)


    const allegatoBase64Uploader = async (event) => {

        const file = event.files[0];

        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onloadend = function (e) {
            if (file.size < 2500000) {
                let b64payload = btoa(e.target.result);
                const content = e.target.result;
                let _allegato = allegato.splice(0)
                _allegato.push({ data: b64payload, name: file.name, size: file.size, type: file.type })
                setAllegato(_allegato)

                allegatoRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', life: 10000, summary: getText("INFORMAZIONE"), detail: getText("FILE_BIGGER_THAN_ALLOWED") });
                allegatoRef.current.clear();
            }

        };
    };


    const dettagliCode = useMemo(() => ({
        "U": [
            {
                "categoria_principale": getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"), value: "-", coda_team_competente: "[OQ:Career Service::Problemi Tecnici]  " + otoboFunctionalEmail }
                ]

            }
        ],

        "A": [

            {
                "categoria_principale": getText("CAREER_SERVICE_TIROCINI"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_TIROCINI_ATTIVAZIONE_GESTIONE_CANDIDATO_GIA_INDIVIDUATO"), value: "candidato_gia_individuato", coda_team_competente: "[OQ:Career Service::Tirocini]  " + otoboFunctionalEmail },
                    { name: getText("CAREER_SERVICE_TIROCINI_RICERCA_CANDIDATO"), value: "ricerca_candidato", coda_team_competente: "[OQ:Career Service::Employer Relations]" + otoboFunctionalEmail }

                ]

            },
            {
                "categoria_principale": getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"), value: "-", coda_team_competente: "[OQ:Career Service::Problemi Tecnici]  " + otoboFunctionalEmail }
                ]

            },
            {
                "categoria_principale": getText("CAREER_SERVICE_EVENTI_INCONTRI_STUDENTI_EMPLOYER_BRANDING"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_EVENTI_INCONTRI_STUDENTI_EMPLOYER_BRANDING"), value: "-", coda_team_competente: "[OQ:Career Service::Employer Relations]" + otoboFunctionalEmail }
                ]
            },
            {
                "categoria_principale": getText("CAREER_SERVICE_RICERCA_CANDIDATI_INFO_PUBBLICAZIONE_ANNUNCI"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_RICERCA_CANDIDATI_INFO_PUBBLICAZIONE_ANNUNCI"), value: "-", coda_team_competente: "[OQ:Career Service::Employer Relations]" + otoboFunctionalEmail }
                ]
            },
            {
                "categoria_principale": getText("CAREER_SERVICE_INFO_CREDENZIALI_REGISTRAZIONE_AGGIORNAMENTO_DATI_AZIENDALI"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_INFO_CREDENZIALI_REGISTRAZIONE_AGGIORNAMENTO_DATI_AZIENDALI"), value: "-", coda_team_competente: "[OQ:Career Service::Employer Relations]" + otoboFunctionalEmail }
                ]

            }
        ],
        "S": [
            {
                "categoria_principale": getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"), value: "-", coda_team_competente: "[OQ:Career Service::Problemi Tecnici]  " + otoboFunctionalEmail }
                ],

            },
            {
                "categoria_principale": getText("CAREER_SERVICE_TIROCINI"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_TIROCINI_ATTIVAZIONE_GESTIONE_AZIENDA_GIA_INDIVIDUATA"), value: "azienda_gia_individuata", coda_team_competente: "[OQ:Career Service::Tirocini]  " + otoboFunctionalEmail },
                    { name: getText("CAREER_SERVICE_TIROCINI_RICERCA_AZIENDA"), value: "ricerca_azienda", coda_team_competente: "[OQ:Career Service::Tirocini]  " + otoboFunctionalEmail }
                ]
            },
            {
                "categoria_principale": getText("CAREER_SERVICE_EVENTI_INCONTRI_AZIENDE_ENTI"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_EVENTI_INCONTRI_AZIENDE_ENTI"), value: "-", coda_team_competente: "[OQ:Career Service::Orientamento ed Eventi]  " + otoboFunctionalEmail }
                ]

            },
            {
                "categoria_principale": getText("CAREER_SERVICE_RICERCA_LAVORO"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_RICERCA_LAVORO"), value: "-", coda_team_competente: "[OQ:Career Service::Orientamento ed Eventi]  " + otoboFunctionalEmail }
                ]
            },
            {
                "categoria_principale": getText("CAREER_SERVICE_ORIENTAMENTO_E_IMPRENDITORIALITA"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_ORIENTAMENTO_E_IMPRENDITORIALITA"), value: "-", coda_team_competente: "[OQ:Career Service::Orientamento ed Eventi]  " + otoboFunctionalEmail }
                ]
            },
            {
                "categoria_principale": getText("CAREER_SERVICE_CURRICULUM_VITAE_E_PROFILO_PERSONALE"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_CURRICULUM_VITAE_E_PROFILO_PERSONALE"), value: "-", coda_team_competente: "[OQ:Career Service::Orientamento ed Eventi]  " + otoboFunctionalEmail }
                ]
            }
        ],
        "D": [
            {
                "categoria_principale": getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_PROBLEMA_TECNICO_SUL_SITO"), value: "-", coda_team_competente: "[OQ:Career Service::Problemi Tecnici]  " + otoboFunctionalEmail }
                ],

            },
            {
                "categoria_principale": getText("CAREER_SERVICE_TIROCINI"),
                "sottocategorie": [
                    { name:  getText("CAREER_SERVICE_TIROCINI_APPROVAZIONE_PREVENTIVA"), value: "convalida_cfu", coda_team_competente: "[OQ:Career Service::Tirocini]  " + otoboFunctionalEmail },
                    { name: getText("CAREER_SERVICE_TIROCINI_CONVALIDA_FINALE"), value: "altro", coda_team_competente: "[OQ:Career Service::Tirocini]  " + otoboFunctionalEmail }
                ]

            },
            {
                "categoria_principale":  getText("CAREER_SERVICE_INFO_EVENTI_SERVIZI_STUDENTI"),
                "sottocategorie": [
                    { name: getText("CAREER_SERVICE_INFO_EVENTI_SERVIZI_STUDENTI"), value: "-", coda_team_competente: "[OQ:Career Service::Orientamento ed Eventi]  " + otoboFunctionalEmail }
                ]
            }
        ]
    }), [getText]);

    useEffect(() => {
        document.title = "Career Service";

        if (isLogged) {
            setNome(userInfo.nome)
            setCognome(userInfo.cognome)
            setEmail(userInfo.email)
            setCodice_persona(userInfo.codicePersona)
        } else if ("A" === queryParams.get('categoria') && queryParams.get('email') != null) {
            console.log("set email from params: ", queryParams.get('email'))
            console.log("set cat from params: ", queryParams.get('categoria'))
            setCategoria(queryParams.get('categoria'))
            setNome(queryParams.get('nome'))
            setCognome(queryParams.get('cognome'))
            setEmail(queryParams.get('email'))
            setCodice_persona(queryParams.get('codicePersona'))
        }
    }, [isLogged, queryParams]);

    const progettoPreliminareFileUploadRef = useRef(null);

    const progettoPreliminareBase64Uploader = async (event) => {
        // convert file to base64 encoded
        const file = event.files[0];

        const reader = new FileReader();
        reader.readAsBinaryString(file);


        reader.onloadend = function (e) {
            if (file.size < 2500000) {

                let b64payload = btoa(e.target.result);
                setProgettoPreliminare({ data: b64payload, name: "PROGETTO_PRELIMINARE_" + file.name, size: file.size, type: file.type })
                progettoPreliminareFileUploadRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', life: 10000, summary: getText("INFORMAZIONE"), detail: getText("FILE_BIGGER_THAN_ALLOWED") });
                progettoPreliminareFileUploadRef.current.clear();
            }
        };
    };

    useEffect(() => {
        console.log("selectedQueue changed: ", selectedQueue)
    }, [selectedQueue]);

    useEffect(() => {
        if (categoria != null) {
            setCategoriaPrincipaleList(dettagliCode[categoria].map(item => { return { name: item.categoria_principale, value: item.categoria_principale } }))
            setSottocategoriaPrincipale(null)
            setCategoriaPrincipale(null)
            setSelectedQueue(null)
        } else {
            setCategoriaPrincipaleList([])
            setSelectedQueue(null)
        }
    }, [categoria]);

    useEffect(() => {
        setSelectedQueue(null)

        if (categoriaPrincipale != null) {
            setSottocategoriaPrincipale(null)
            const dettaglio = dettagliCode[categoria].find(item => item.categoria_principale === categoriaPrincipale)
            if (dettaglio) {
                console.log("dettaglio: ", dettaglio)
                setSottocategoriaPrincipaleList(dettaglio.sottocategorie)
                if (dettaglio.sottocategorie.length == 1) {
                    setSottocategoriaPrincipale(dettaglio.sottocategorie[0].value)
                    setSelectedQueue(dettaglio.sottocategorie[0])
                } else {
                    setSottocategoriaPrincipale(null)

                }
            } else {
                setSottocategoriaPrincipaleList([])
            }
        } else {
            setSottocategoriaPrincipaleList([])
        }
    }, [categoriaPrincipale]);


    const createNewTicket = () => {
        setTicketSent(false)

    }

    useEffect(() => {
        console.log("sottocategoriaPrincipale changed: ", sottocategoriaPrincipale)
        if (sottocategoriaPrincipale != null && sottocategoriaPrincipale !== "") {
            const dettaglio = dettagliCode[categoria].find(item => item.categoria_principale === categoriaPrincipale)
            if (dettaglio == null) return;
            const sottocategoria = dettaglio.sottocategorie.find(sub => sub.value === sottocategoriaPrincipale)
            console.log("sottocategoria: ", sottocategoria)
            setSelectedQueue(sottocategoria)
        }
    }, [sottocategoriaPrincipale]);

    const sendTicket = () => {


        const request = {
            nome: nome,
            cognome: cognome,
            email: email != null && email.trim() !== "" ? email : typedEmail,
            codicePersona: codice_persona != null ? codice_persona : null,
            oggetto: oggetto,
            testo: testo,
            queue: selectedQueue.coda_team_competente,
            //dynamicFields: dynamicFields != null ? dynamicFields : null,
            allegati: allegato
        }

        var url = '/nuovaRichiesta/sendCareerServiceTicket';
        setLoading(true)
        PJAxios().post(url, request).then((res) => {
            setTicketSent(res.data)
            if (res.data) {
                toast.current.show({ severity: 'success', summary: getText("INFORMAZIONE"), detail: getText("TICKET_CREATED_SUCCESSFULLY") });
            } else {
                toast.current.show({ severity: 'danger', summary: getText("INFORMAZIONE"), detail: getText("ERROR_CREATING_TICKET") });
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const validForm = () => {
        var valid = oggetto.trim() !== "" && testo.trim() !== "" && selectedQueue !== "" && !ticketSent;

        return valid;
    }

    const sediList = [
        { name: getText("CITTA_STUDI"), code: 'MI', queue: '[OQ:AGIS::Eventi::Leonardo]' },
        { name: getText("BOVISA"), code: 'BO', queue: '[OQ:AGIS::Eventi::Bovisa]' }
    ];

    const rimuoviAllegato = (indexDaRimuovere) => {
        // Filtriamo l'array escludendo l'elemento con l'indice selezionato
        const nuoviAllegati = allegato.filter((_, index) => index !== indexDaRimuovere);

        // Aggiorniamo lo stato (presumendo che la funzione si chiami setAllegato)
        setAllegato(nuoviAllegati.length > 0 ? nuoviAllegati : []);
    };

    return (
        <>
            <Toast ref={toast} position="top-right" />
            {loading &&
                <div className="loading-overlay">
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            {!loading &&

                <PJPage>
                    <PJHeader>{getText("CAREER_SERVICE")}</PJHeader>
                    <PJContent>
                        {email != null && email !== "" &&
                            <>
                                <div className='formgroup-inline col-12'>
                                    <div className='col-2'>
                                        <b>{getText("FROM_CAREER_SERVICE")}</b>
                                    </div>
                                    <div className='col-10'>
                                        <b></b>{cognome} {nome} ({email})
                                    </div>
                                </div>
                                {codice_persona != null &&
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2'>
                                            <b>{getText("PERSONAL_CODE")}</b>
                                        </div>
                                        <div className='col-10'>
                                            {codice_persona}
                                        </div>
                                    </div>

                                }

                                <div className='formgroup-inline col-12'>
                                    <div className='col-2'>
                                        <b>{getText("USER_CATEGORY")}</b>
                                    </div>
                                    <div className='col-10'>
                                        {queryParams.categoria != null && categoriaList.find(cat => cat.value === queryParams.categoria).name}

                                        {queryParams.categoria == null &&
                                            <Dropdown style={{ width: "100%" }} disabled={ticketSent} value={categoria} onChange={(e) => setCategoria(e.value)} options={categoriaList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} />
                                        }

                                    </div>
                                </div>
                                {categoria != null &&
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2'>
                                            <b>{getText("TECHNICAL_CATEGORY")}</b>
                                        </div>
                                        <div className='col-10'>
                                            <Dropdown style={{ width: "100%" }} disabled={ticketSent} value={categoriaPrincipale} onChange={(e) => setCategoriaPrincipale(e.value)} options={categoriaPrincipaleList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} />
                                        </div>
                                    </div>
                                }
                                {categoriaPrincipale != null && sottocategoriaPrincipaleList != null && sottocategoriaPrincipaleList.length > 1 &&
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2'>
                                            <b>{getText("TECHNICAL_SUBCATEGORY")}</b>
                                        </div>
                                        <div className='col-10'>
                                            <Dropdown style={{ width: "100%" }} disabled={ticketSent} value={sottocategoriaPrincipale} onChange={(e) => { console.log(e); setSottocategoriaPrincipale(e.value) }} options={sottocategoriaPrincipaleList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} />
                                        </div>
                                    </div>
                                }

                                <div className='formgroup-inline col-12'>
                                    <div className='col-2'>
                                        <b>{getText("OGGETTO_CAREER_SERVICE")}</b>
                                    </div>
                                    <div className='col-10'>
                                        <InputText style={{ width: "100%" }} placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="name" value={oggetto} onChange={(e) => setOggetto(e.target.value)} />
                                    </div>
                                </div>
                                <div className='formgroup-inline col-12'>
                                    <div className='col-2'>
                                        <b>{getText("DESCRIZIONE_CAREER_SERVICE")}</b>
                                    </div>
                                    <div className='col-10'>
                                        <InputTextarea style={{ width: "100%" }} placeholder={getText("SCRIVI_QUALCOSA")} rows={5} cols={100} className="width500px p-inputtext-sm block mb-2 " id="name" value={testo} onChange={(e) => setTesto(e.target.value)} />
                                    </div>
                                </div>
                                {false &&
                                    <div className='formgroup-inline col-12'>
                                        <div className='col-2'>
                                            <b>{getText("SEND_TO")}</b>
                                        </div>
                                        <div className='col-10'>
                                            {selectedQueue != null && selectedQueue.name}
                                        </div>
                                    </div>
                                }
                                <div className='formgroup-inline col-12'>
                                    <div className='col-2'>
                                        <b>{getText("ATTACHMENTS")}</b>
                                    </div>
                                    <div className='col-10'>
                                        <FileUpload style={{ marginBottom:"15px"}}disabled={ticketSent} ref={allegatoRef} mode="basic" customUpload uploadHandler={allegatoBase64Uploader} name="demo[]" accept="*" maxFileSize={10000000} />
                                       <Chip style={{ width: "auto"}} className="no-bg" icon="pmi-line pmi-16 pmi-line-comment-info pj-text-warning" label={getText("NOTA_CAREER_SERVICE")} />
                                        <div className='col-12 mt-2'>
                                            {allegato != null && (
                                                <div className="d-flex flex-column gap-2">
                                                    {allegato.map((file, index) => (
                                                        <div key={index} className="d-flex align-items-center justify-content-between p-2  formgroup-inline rounded">
                                                            <span className='col-10'>
                                                                <strong>{file.name}</strong> ({Math.round(file.size / 1024)} KB)
                                                            </span>
                                                            <span className='col-2'>
                                                                <PJButton
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => rimuoviAllegato(index)}
                                                                    disabled={ticketSent}
                                                                >
                                                                    <i className="pi pi-trash"></i> {/* Se usi PrimeIcons */}
                                                                    Rimuovi
                                                                </PJButton>
                                                            </span>

                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='formgroup-inline col-12'>
                                    <PJButton label={getText("INVIA")} disabled={!validForm() || ticketSent} onClick={() => sendTicket()}></PJButton>
                                    {ticketSent &&
                                        <PJButton className="ml-2" label={getText("NUOVA_RICHIESTA")} onClick={() => createNewTicket()}></PJButton>
                                    }
                                </div>
                            </>
                        }

                        {email == null &&
                            <div className='formgroup-inline col-12'>
                                <div className='col-12'>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <h4>{getText("LOGIN_TO_SEND_REQUEST")}</h4>
                                        <div>&nbsp;&nbsp;</div>
                                        <div className='formgroup-inline'>
                                            <PJButton className="ml-2" label={getText("LOGIN")} onClick={() => { sessionStorage.setItem("postLoginRedirect", window.location.href); sendLogin() }}></PJButton>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        }


                    </PJContent>
                </PJPage>
            }


        </>
    )
}

export default CareerServiceForm
